//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'LungAge',
  data () {
    return {
      defaultJson:{
        "Height": "身高",
        "Lung Age": "肺龄",
        "Measured FEV₁": "FEV₁ 测定值"
      },
      form: {
        gender:'1',
        h:'',
        f:'',
      },
      hasScore: false,
      disabled: false,
      dataList2: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false  
        return '--'
      } else {
        console.log(form)
        	// gender.isMale ? (((0.0414*h) - 2.19 -  f) / 0.0244) : (((0.0342*h) - 1.578 - f) / 0.0255)
        //  form.
        let result =form.gender=='1' ? (((0.0414*form.h) - 2.19 -  form.f) / 0.0244) : (((0.0342*form.h) - 1.578 - form.f) / 0.0255)

        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/LungAge.vue